import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from "react-router-dom";
import PlantillaScreen from '../../helpers/PlantillaScreen'
import { Autocomplete, TextField } from '@mui/material';
import request from '../../../Helpers/API';
import Swal from 'sweetalert2';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { GetKey, GetText } from '../../../Helpers/GetKey';
import { LoaderScreen } from '../../components/LoaderScreen';
import { AnalisisCreditoFiltro } from '../../AnalisisCredito/AnalisisCreditoFiltro';
import { FormatMoney } from '../../../Helpers/FormatNumber';


export const ReestructuracionCreditoMainScreen = () => {
    const history = useHistory();
    const location = useLocation();
    const [clienteslist, setClienteList] = useState([]);
    const [clienteselect, setClienteSelect] = useState("");
    const [cliente, setCliente] = useState("")
    const [solicitudes, setSolicitudes] = useState({
        tablero: [],
        tabla: [],
        vendedores: [],
        sucursales: [],
    });
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });


    // Filtros
    const [filtroRazonSocial, setFiltroRazonSocial] = useState("");
    const [filtroTipoSolicitud, setFiltroTipoSolicitud] = useState("");
    const [filtroLineaCredito, setFiltroLineaCredito] = useState([]);
    const [filtroEstado, setFiltroEstado] = useState("");
    const [filtroSucursal, setFiltroSucursal] = useState("");
    const [filtroVendedor, setFiltroVendedor] = useState("");
    const [filtroFolio, setFiltroFolio] = useState("");

    //guardar el cliente de regreso, una vez se selecciona
    useEffect(() => {
        // Obtener el cliente del estado (si existe) de la ruta actual
        const locationCliente = location.state ? location.state.cliente : null;
        if (locationCliente) {
            setClienteSelect(locationCliente);
        }
    }, [location]);


    useEffect(() => {
        request
            .get("Clientes/DropDownList")
            .then((result) => {
                setClienteList(result);
            })
            .catch((error) => {
                Swal.fire("SOLICITUD DE CREDITO", JSON.stringify(error), "error");
            });
    }, []);

    useEffect(() => {
        // if (idcliente !== null && idcliente !== undefined || idcliente !== "") {
        //     setClienteSelect(idcliente)

        if (clienteselect !== "") {
            obtenerDatos()
        }

    }, [clienteselect])

    const obtenerDatos = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ReestructurarCredito/ListadoSolicitudes?idcliente=${GetKey(clienteselect)}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setSolicitudes({
                    tablero: result.tablero,
                    tabla: result.tablero,
                    vendedores: result.vendedor,
                    sucursales: result.sucursal,
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("SOLICITUDES DE CREDITO", JSON.stringify(error), "error");
            });
    }

    const onRegresar = () => {
        if (clienteselect !== null && clienteselect !== undefined && clienteselect !== "") {
            setCliente("")
            setClienteSelect("")
        } else {
            history.push("/Credito/Main");
        }
    }

    const capitalizeWords = (str) => {
        return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
    };

    // Contador de solicitudes visibles
    const numeroDeSolicitudes = solicitudes.tabla.length;

    const onReestructurar = (folio) => {
        history.push({
            pathname: "/Credito/ReestructurarCreditoCondiciones",
            state: {
                cliente: clienteselect,
                folio: folio
            },
        });
    }

    const onFiltrar = (
        folio,
        asesor,
        razon_social,
        sucursal,
        estado,
        tipo_solicitud,
        linea_credito,
    ) => {
        return new Promise((resolve, reject) => {
            var newtabla = solicitudes.tablero;

            // Aplicar filtros a la tabla
            if (folio != undefined && folio !== null && folio != "") {
                newtabla = newtabla.filter((item) => item.folio === folio);
            } else {
                if (asesor != undefined && asesor !== null && asesor != "") {
                    newtabla = newtabla.filter((item) => item.vendedor === asesor);
                }
                if (razon_social != undefined && razon_social !== null && razon_social != "") {
                    newtabla = newtabla.filter((item) => item.razon_social === razon_social);
                }
                if (sucursal != undefined && sucursal !== null && sucursal != "") {
                    newtabla = newtabla.filter((item) => item.sucursal === sucursal);
                }
                if (estado != undefined && estado !== null && estado != "") {
                    newtabla = newtabla.filter((item) => item.estado === estado);
                }
                if (tipo_solicitud != undefined && tipo_solicitud !== null && tipo_solicitud != "") {
                    newtabla = newtabla.filter((item) => item.tipo_credito === tipo_solicitud);
                }
                if (linea_credito != undefined && linea_credito !== null && linea_credito != "") {
                    newtabla = newtabla.filter((item) => item.linea_credito === linea_credito);
                }
            }

            // Actualiza la tabla en el estado local
            setSolicitudes({ ...solicitudes, tabla: newtabla });
            resolve("");
            return;
        });
    };

    return (
        <PlantillaScreen
            titulo={`REESTRUCTURAR CREDITO ${clienteselect !== "" ? "-" + GetText(clienteselect) : ""}`}
            className_main={1}
            className={"reestructuracion-credito-main-screen"}
        >
            <LoaderScreen loader={loader} />

            <div className="reestructurar-credito-boton-regresar-container">
                <button
                    className="reestructurar-credito-boton-regresar "
                    onClick={() => onRegresar()}
                >
                    <ArrowBackIcon />
                    REGRESAR
                </button>
            </div>


            {clienteselect === "" ? (
                <div className='reestructurar-credito-buscar-cliente-container'>
                    <Autocomplete
                        size="small"
                        id="dash-razonsocial"
                        freeSolo
                        className="reestructurar-credito-buscar-cliente-autocomplete"
                        value={clienteselect}
                        onChange={({ target }) => {
                            setClienteSelect(target.outerText);
                            setCliente(target.value);
                        }}
                        options={clienteslist.map(option => `${option.id} - ${option.display}`)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="SELECCIONAR CLIENTE"
                            // onKeyDown={(e) => {
                            //   if (e.key === 'Enter') {
                            //     handleEnterKeyPress(); 
                            //   }
                            // }}
                            />
                        )}
                    />
                </div>
            ) : (
                <div className="reestructurar-credito-solicitud-container">
                    <div className="reestructurar-credito-solicitudes-container-filtros">
                        {/* <AnalisisCreditoFiltro
                            tablero={solicitudes.tablero}
                            filtroRazonSocialB={filtroRazonSocial}
                            setFiltroRazonSocialB={setFiltroRazonSocial}
                            filtroTipoSolicitudB={filtroTipoSolicitud}
                            setFiltroTipoSolicitudB={setFiltroTipoSolicitud}
                            filtroLineaCreditoB={filtroLineaCredito}
                            setFiltroLineaCreditoB={setFiltroLineaCredito}
                            filtroEstadoB={filtroEstado}
                            setFiltroEstadoB={setFiltroEstado}
                            filtroSucursalB={filtroSucursal}
                            setFiltroSucursalB={setFiltroSucursal}
                            filtroVendedorB={filtroVendedor}
                            setFiltroVendedorB={setFiltroVendedor}
                            setFiltroFolioB={setFiltroFolio}
                            filtroFolioB={filtroFolio}
                            onFiltrar={onFiltrar}
                        /> */}
                        <div></div>

                        <div className="contador-solicitudes">
                            Número de operaciones: {numeroDeSolicitudes}
                        </div>
                    </div>
                    <div className="reestructurar-credito-tabla-solicitudes-container scroll-4">
                        <table cellPadding={0} cellSpacing={0}>
                            <thead>
                                <tr className="tr-columnas">
                                    <th>Folio</th>
                                    <th><div>Sucursal</div></th>
                                    <th>
                                        <div>Cliente</div>
                                    </th>
                                    <th>
                                        <div>Asesor de Venta</div>
                                    </th>
                                    <th>
                                        <div>Tipo de Solicitud</div>
                                    </th>
                                    <th>
                                        <div>Linea</div>
                                    </th>
                                    <th>
                                        <div>Estado</div>
                                    </th>
                                    <th>
                                        <div>Importe</div>
                                    </th>
                                    <th>
                                        <div>Fecha</div>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {solicitudes.tabla.map((item) => (
                                    <tr
                                    // onClick={() =>
                                    //     onOpenSolicitud(item.folio)
                                    // }
                                    >
                                        <td>{item.folio}</td>
                                        <td>{capitalizeWords(item.sucursal)}</td>
                                        <td>{capitalizeWords(item.razon_social)}</td>
                                        <td>{item.vendedor}</td>
                                        <td>{capitalizeWords(item.tipo_credito)}</td>
                                        <td>{capitalizeWords(item.linea_credito)}</td>
                                        <td>{item.estado}</td>
                                        <td style={{ textAlign: 'right' }}>{FormatMoney(item.importe)}</td>
                                        <td>{item.fecha}</td>
                                        {item.estado === "Aprobada" ? (
                                            <td><div className='reestructurar-solicitud-boton' onClick={() => onReestructurar(item.folio)}>reestructurar</div></td>
                                        ) : (<td></td>)}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </PlantillaScreen >
    )
}
